import { createFileRoute } from '@tanstack/react-router'

import { NodeConnectionList } from '@/licenses-tree/components/NodeConnectionList'

export const Route = createFileRoute(
  '/company/_management/licenses-structure/$nodeId/_panel/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <NodeConnectionList />
}
